import { render, staticRenderFns } from "./InsertButton.vue?vue&type=template&id=16d4aa23"
import script from "./InsertButton.vue?vue&type=script&lang=js"
export * from "./InsertButton.vue?vue&type=script&lang=js"
import style0 from "./InsertButton.vue?vue&type=style&index=0&id=16d4aa23&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d4aa23')) {
      api.createRecord('16d4aa23', component.options)
    } else {
      api.reload('16d4aa23', component.options)
    }
    module.hot.accept("./InsertButton.vue?vue&type=template&id=16d4aa23", function () {
      api.rerender('16d4aa23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/InsertButton.vue"
export default component.exports